import { createContext } from 'react';

/** Portals preserve React ancestry even though every host is a root sibling. */
export const OverlayDepth = createContext(0);
